/**
 * Fixed platform-wide responsive max-width wrapper (spec §5 — the layout shell
 * is fixed, not per-org). Centers content and applies the standard horizontal
 * gutters. Pure presentational; server-compatible.
 */
export function Container({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8 ${className}`.trim()}
    >
      {children}
    </div>
  );
}
